import { keyCodes } from '../../../shared/constants/keyboard';
import { select } from '../../../shared/utils/dom';
import { isPhoneValid } from '../../../shared/constants/validation';
import { createAccount } from '../../api';
import { createError, removeError } from '../../../shared/formErrors';

// re-assign some API methods
const { getSecondaryLookupField } = createAccount;

/**
 * Handle the JSON response of the lookup for getting secondary lookup field
 * @this Vue The Vue app instance
 * @param {object} response
 * @param {string} response.hasDateOfBirth
 * @param {string} response.hasTaxId
 * @param {string} response.hasLastFourSocial
 */
function secondaryLookupEmit(response) {
  this.$emit('lookup-phone-response', response);
}

/**
 * Account lookup component
 */
Vue.component('phone-lookup', {
  template: `
  <div class="form-field__wrapper">
    <label for="phone-input" id="phone-label">
      Phone Number
      <input id="phone-input" type="tel" placeholder="(XXX) XXX-XXXX" v-mask="'(###) ###-####'" class="w-100"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:keyup="keyupPhone"
      >
    </label>
    <button class="btn" disabled="disabled" type="button"
      v-bind:disabled="disabledSearchByPhone"
      v-on:keyup.enter="clickSearchByPhone"
      v-on:click.self="clickSearchByPhone"
      id="search-by-phone"
      >
      <span class="btn-inner">Search</span>
    </button>
  </div>
  `,

  /**
   * Props array
   */
  props: {
    value: { required: true },
    ldc: { default: null },
    showVerifyFields: { default: false },
    loading: false,
    reproofing: { type: Boolean, default: false },
  },

  created() {
  },

  /**
   * Data function
   */
  data() {
    return {
      disabledSearchByPhone: true,
    }
  },

  methods: {
    /**
     * Click on search by phone number
     */
    clickSearchByPhone() {
      const phoneNumberInput = select('#phone-input');
      if (this.unmaskedPhoneNumber !== '' && isPhoneValid(this.unmaskedPhoneNumber)) {
        // remove error if phone number is valid
        removeError(phoneNumberInput, this.$parent.$refs.phoneNumberError);
        this.$emit('component-loading', this.loading = true);
        this.noAccountsFound = false;
        Event.$emit('UpdateNoAccountsFoundFlag', { noAccountsFound: this.noAccountsFound });
        if (window.fabricator) {
          setTimeout(() => {
            secondaryLookupEmit.call(this, { dateOfBirthCount: 1 });
            this.showVerifyFields = true;
            this.$emit('component-loading', this.loading = false);
          }, 500);
        } else {
          getSecondaryLookupField({ phone: this.unmaskedPhoneNumber, ldc: this.ldc }, this.reproofing)
            .then(response => {
              // parse the response
              if (typeof response.data !== "undefined" && response.status === 200) {
                // parse the response
                this.$emit('lookup-phone-response', response.data);
                this.showVerifyFields = true;
                this.$emit('component-loading', this.loading = false);
              }
            })
            .catch((err) => {
              // display error of what went wrong
              if (err.response && err.response.status === 400) {
                this.$emit('component-loading', this.loading = false);
                this.noAccountsFound = true;
                Event.$emit('UpdateNoAccountsFoundFlag', { noAccountsFound: this.noAccountsFound });
              }
            });
        }
      } else {
        // if phone number was invalid, show error
        createError(phoneNumberInput, this.$parent.$refs.phoneNumberError, 'Please provide a valid phone number.');
      }
    },

    /**
     * Keyup on phone field
     */
    keyupPhone(event) {
      // anything but enter key
      if (event.keyCode !== keyCodes.enter) {
        if (this.value) {
          this.disabledSearchByPhone = false
        }
      } else if (!this.disabledSearchByPhone) {
        // enter key should submit if submit button enabled
        this.clickSearchByPhone();
      }
    },
  },

  computed: {
    unmaskedPhoneNumber() {
      return this.value ? this.value.replace(/\D/g, "") : '';
    },
  },

});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/components/phoneLookup.js